import h from "../helpers";
import { request } from "../helpers/httpInterceptor";
import { Dispatch } from "../types/types";
import { notifyGreen } from "./notifyActions";
import {
    IDestinationGroupingParents,
    ISetDestinationGroupingParents,
    ISetLoadingDestinationGroupingParents,
    ISetSavingDestinationGroupingParents,
    ISetCompletedDestinationGroupingParents,
} from "../types/stores/destinationGroupingParents";
import {
    SET_DESTINATIONGROUPINGPARENTS,
    SET_LOADING_DESTINATIONGROUPING_PARENTS,
    SET_DESTINATIONGROUPINGPARENT_DETAILS,
    SET_IS_SAVING_DESTINATIONGROUPING_PARENTS,
    SET_SAVE_COMPLETED_DESTINATIONGROUPING_PARENTS,
} from "../reducers/destinationGroupingParents";

export const SetDestinationGroupingParentsLoading = (newValue: boolean): ISetLoadingDestinationGroupingParents => ({
    type: SET_LOADING_DESTINATIONGROUPING_PARENTS,
    isLoading: newValue,
});

export const SetDestinationGroupingParentsSaving = (newValue: boolean): ISetSavingDestinationGroupingParents => ({
    type: SET_IS_SAVING_DESTINATIONGROUPING_PARENTS,
    isSaving: newValue,
});

export const SetDestinationGroupingParentsCompleted = (newValue: boolean): ISetCompletedDestinationGroupingParents => ({
    type: SET_SAVE_COMPLETED_DESTINATIONGROUPING_PARENTS,
    completed: newValue,
});

export const SetDestinationGroupingParents = (
    data: Array<IDestinationGroupingParents>
): ISetDestinationGroupingParents => ({
    type: SET_DESTINATIONGROUPINGPARENTS,
    destinationGroupingParents: data,
});

export const SetDestinationGroupingParentDetails =
    (data: IDestinationGroupingParents) =>
    (dispatch: Dispatch): void => {
        dispatch({
            type: SET_DESTINATIONGROUPINGPARENT_DETAILS,
            destinationGroupingParent: data,
        });
    };

export const GetDestinationGroupingParents =
    (status?: string) =>
    (dispatch: Dispatch): void => {
        dispatch(SetDestinationGroupingParentsLoading(true));
        return request(
            `/DestinationGroupingParents/GetDestinationGroupingParents/status=${status}`,
            { credentials: "same-origin" },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDestinationGroupingParentsLoading(false));
                dispatch(SetDestinationGroupingParents(data));
            })
            .catch(error => {
                dispatch(SetDestinationGroupingParentsLoading(false));
                h.error("Error getting user companies.", error);
            });
    };

export const AddEditDestinationGroupingParent =
    (defaultGroupParent: IDestinationGroupingParents) =>
    (dispatch: Dispatch): any => {
        if (!defaultGroupParent.ParentName) dispatch(SetDestinationGroupingParentsSaving(true));

        return request(
            `/DestinationGroupingParents/AddEditDestinationGroupingParent`,
            {
                credentials: "same-origin",
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    DestinationGroupingParentID: defaultGroupParent.DestinationGroupingParentID,
                    ParentName: defaultGroupParent.ParentName,
                    ParentIcon: defaultGroupParent.ParentIcon,
                    Description: defaultGroupParent.Description,
                    SubDestinations: defaultGroupParent.SubDestinations,
                }),
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDestinationGroupingParentsSaving(false));
                dispatch(SetDestinationGroupingParentsCompleted(true));

                setTimeout(() => {
                    dispatch(SetDestinationGroupingParentsCompleted(false));
                }, 200);

                if (data && data.success) {
                    dispatch(notifyGreen("Successfully saved your new destination grouping parent."));
                    dispatch(GetDestinationGroupingParents());
                } else if (!data.success && data.message) {
                    return data.message;
                }
            })
            .catch(error => {
                dispatch(SetDestinationGroupingParentsSaving(false));
                h.error("Error saving new destination grouping parent.", error);
            });
    };

export const DeleteDestinationGroupingParent =
    (parentId: number) =>
    (dispatch: Dispatch): any =>
        request(
            `/DestinationGroupingParents/DeleteDestinationGroupingParents?parentId=${parentId}`,
            {
                method: "POST",
                credentials: "same-origin",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                dispatch(SetDestinationGroupingParentsSaving(false));
                dispatch(SetDestinationGroupingParentsCompleted(true));

                setTimeout(() => {
                    dispatch(SetDestinationGroupingParentsCompleted(false));
                }, 200);

                if (data && data.success) {
                    dispatch(notifyGreen("Successfully deleted your new destination grouping parent."));
                    dispatch(GetDestinationGroupingParents());
                } else if (!data.success && data.message) {
                    return data.message;
                }
            })
            .catch(error => {
                dispatch(SetDestinationGroupingParentsSaving(false));
                h.error("Error deleting the destination grouping parent.", error);
            });
